import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import TitleBtn from '../components/TitleBtn';
import TitleImage from '../components/TitleImage';
import projectPhoto from '../assets/images/projects.jpg';
import Layoutsvg from '../components/Layoutsvg';
import Menu from '../components/Menu';

//importing animations
import { MainWrapperVariants, MainNameVariants, MainLine1Variants, MainLine2Variants, MainRoleVariants } from '../animations/MainPageAnims';


import { TitleWrapper, TitleDesc } from '../components/StyledComponents/StyledComp';
function Projects() {


  const navigate = useNavigate();

  var scrolled = false;
  function handleScroll(e) {

    if (!scrolled) {
      scrolled = true;
      // console.log("scrolled with project");
      const y = e.wheelDeltaY;
      if (y < 0) {
        navigate("/contact");
      } else {
        navigate("/about");
      }
      // setTimeout(()=> scrolled=false , 2000);
    }
  }

  useEffect(() => {
    setTimeout(() => {

      //FOR MOBILE
      let touchstartX = 0;
      let touchendX = 0;
      let touchstartY = 0;
      let touchendY = 0;
      function handleGesture(e) {
        if (!scrolled) {

          var diffX = touchstartX - touchendX;
          var diffY = touchstartY - touchendY;

          if (Math.abs(diffX) < Math.abs(diffY)){
              if (diffY > 0) {
                  // swiped up
                  // console.log("swiped up");
                  navigate('/contact');
                } else {
                  // swiped down
                  // console.log("swiped down");
                  navigate('/about');
                }  
          }
      }
      }

      const wrapper = document.querySelector(".project-wrapper");


            if(wrapper){
              wrapper.addEventListener('touchstart', e => {
                touchstartX = e.touches[0].clientX;
                touchstartY = e.touches[0].clientY;
            });
            wrapper.addEventListener('touchmove', e => {
                if (touchstartX === null ||  touchstartY === null) {
                    return;
                }

                touchendX = e.touches[0].clientX;
                touchendY = e.touches[0].clientY;
                handleGesture();
            });
                wrapper.addEventListener("wheel", handleScroll);
            }
        }, 1500);
  }, []);

  const gotoDetail = () => {
    // console.log("goto");
    scrolled = true;
    navigate("/projectsdetail");
  }

  return (
    <TitleWrapper className='project-wrapper' >
      <Layoutsvg />
      <Menu />
      <motion.div
      >
        <TitleDesc>
          <motion.p className="title-text"
            variants={MainNameVariants} initial="initial" animate="animate"
          >Projects</motion.p>
          <motion.div className="redline1"
            variants={MainLine1Variants} initial="initial" animate="animate"
          ></motion.div>
          <motion.div className="redline2"
            variants={MainLine2Variants} initial="initial" animate="animate"
          ></motion.div>
          <motion.div className="role"
            variants={MainRoleVariants} initial="initial" animate="animate"
          >
            <p className='title-lead' >Code that left</p>
            <p className='title-lead' >my laptop!</p>
          </motion.div>
          <TitleBtn content="Explore" link='/projects/detail' onClick={gotoDetail} />
        </TitleDesc>
        <TitleImage pageNumber="02" photoSource={projectPhoto} />
      </motion.div>
    </TitleWrapper>
  );
}


export default Projects;